import type { AutocompleteSearchResult } from '@talos/kyoko';
import { useMarketSelectorContext } from '../../MarketSelectorContext';
import type { MarketSelectorCustomPresetItem } from '../../types';
import type { PresetRowEntry } from '../presetListModel';
import { PresetListRowHoverRoot } from '../styles';
import { AggregationPresetRow } from './AggregationPresetRow';

export function AggregationListItem({
  selection,
  searchResult,
  favorite,
  onFavoriteClicked,
  customPresetItemsByID,
  defaultAggregationId,
  onDefaultAggregationChange,
  onActivate,
}: {
  selection: string | undefined;
  searchResult: AutocompleteSearchResult<PresetRowEntry>;
  favorite: boolean;
  onFavoriteClicked: () => void;
  customPresetItemsByID: Map<string, MarketSelectorCustomPresetItem>;
  defaultAggregationId: string | undefined;
  onDefaultAggregationChange: (id: string | undefined) => void;
  onActivate?: () => void;
}) {
  const { isNarrow } = useMarketSelectorContext();
  const row = searchResult.item.item;
  const presetID = row.presetId;
  const isCustom = customPresetItemsByID.has(presetID);
  const isDefault = defaultAggregationId === presetID;
  const isDefaultPin = row.kind === 'aggregation' && row.placement === 'defaultPin';

  const rowTestId = isDefaultPin
    ? 'market-selector-default-aggregation-pinned-row'
    : !isCustom && isDefault
      ? 'market-selector-default-aggregation-row'
      : 'aggregation-list-item';

  return (
    <PresetListRowHoverRoot
      $showDefaultSlotAlways={isNarrow}
      data-testid="market-selector-preset-row-hover-area"
      onClick={onActivate}
    >
      <AggregationPresetRow
        presetID={presetID}
        selection={selection}
        favorite={favorite}
        onFavoriteClicked={onFavoriteClicked}
        customPresetItemsByID={customPresetItemsByID}
        defaultAggregationId={defaultAggregationId}
        onDefaultAggregationChange={onDefaultAggregationChange}
        rowTestId={rowTestId}
        pinnedDefaultRow={isDefaultPin}
      />
    </PresetListRowHoverRoot>
  );
}
